module.exports = __webpack_public_path__ + "img/bniva-light.38c935d3.png";